<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.purchasetypes') }}
      </BaseTopBarContent>
      <BaseTopBarContent
        v-if="hasRoleEdit"
        className="right"
      >
        <div class="action">
          <BaseButton @click="openModalType">
            {{ $t('apps.purchases.button.managetype') }}
          </BaseButton>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseTable
        :hidePagination="true"
        class="custom-table"
        tableClass="table-bordered"
      >
        <template #thead>
          <thead>
            <tr>
              <th>
                {{ $t('apps.purchases.message.purchasetypes') }}
              </th>
              <th
                class="text-center"
                style="width: 150px;"
              >
                {{ $t('message.default') }}
              </th>
              <th
                class="text-center"
                style="width: 150px;"
              >
                {{ $t('message.status') }}
              </th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr
              v-for="(item, index) in purchaseTypes"
              :key="index"
            >
              <td>
                {{ getMasterDataText(item.name, $t) }}
              </td>
              <td class="text-center">
                {{ item.is_default ? $t('message.yes') : '' }}
              </td>
              <td class="text-center">
                <div
                  v-if="item.is_active"
                  class="text-success"
                >
                  <i class="fas fa-check"/>
                  {{ $t('message.enabled') }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>

      <BaseModalCustomMasterData
        v-if="purchaseTypes.length"
        :list="settings"
        :id="MODAL_TYPES"
        :headerText="$t('sidebar.purchasetypes')"
        @onClose="handleCloseModalType"
        @onSubmit="handleSubmitModalType"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'
import { getMasterDataText } from '../../../../helpers'

export default {
  mixins: [userPermissionMixin],
  data () {
    return {
      MODAL_TYPES: 'MODAL_TYPES',
      getMasterDataText,
      loading: true,
      settings: [],
      original_settings: [],
    }
  },
  computed: {
    ...mapGetters({
      purchaseSetting: 'getPurchaseSetting',
    }),
    purchaseTypes() {
      if (this.purchaseSetting && this.purchaseSetting.types) {
        return this.purchaseSetting.types
      }
      return []
    },
    form () {
      return {
        settings: this.settings,
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.purchases.title'),
      current: {
        app_name: 'purchases',
        app_id: 4,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
    })
  },
  methods: {
    ...mapActions([
      'updateSettingsPurchase',
    ]),
    async fetchData () {
      await this.$store.dispatch('setLocalStorageShopInfo')
      this.loading = false

      this.settings = _.cloneDeep(this.purchaseTypes)
      this.original_settings = _.cloneDeep(this.purchaseTypes)
    },
    openModalType() {
      $(`#${this.MODAL_TYPES}`).modal('show')
    },
    handleCloseModalType() {
      this.types = _.cloneDeep(this.original_types)
      $(`#${this.MODAL_TYPES}`).modal('hide')
    },
    async handleSubmitModalType(payload) {
      this.settings = _.cloneDeep(payload)
      this.original_settings = _.cloneDeep(payload)
      const response = await this.updateSettingsPurchase({
        types: payload,
      })
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
      }

      $(`#${this.MODAL_TYPES}`).modal('hide')
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/type/List.vue